import Axios from "axios";
import { URLS } from "./urls";


export const getProjectsInfoForOverview = (data) => Axios.post(URLS.GET_PROJECTS_INFO_FOR_OVERVIEW, data);